exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.grid-detail {\ntable, .detail-content-wrap, .detail-content-item {\n    width: 100%!important;\n}\nimg {\n    width: 100%;\n}\n}\n.grid-attribute {\ntable {\n    width: 100%!important;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-70bd38fc","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/view/zizhi/sysnc.vue
// module id = 1575
// module chunks = 0